<div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back.emit(true)">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
</div>
@if (isPaidUser) {
  <div class="tw-fixed tw-right-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" routerLink="/cart">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'shopping_cart'"></cs-icon><span class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-black tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{ numberOfProductsInCart }}</span>
  </div>
}
<div class="tw-flex tw-flex-col tw-h-full">
  <div class="tw-flex-1 tw-overflow-y-auto" #articleBlock="" [ngClass]="{ 'overrideBootstrap': article && article.get('cssLink') }">
    @if (cssLink) {
      <link itemprop="url" rel="stylesheet" [href]="cssLink" />
    }
    @if (articleHeaderImage) {
      <img [src]="articleHeaderImage" />
    }
    @if (innerHTML) {
      <div [innerHTML]="innerHTML"></div>
    }
    @if (showRefundPolicyOption) {
      <refund-policy></refund-policy>
    }
  </div>
  @if (isPaidUser && product?.price !== 0 && innerHTML && clickToAction && clickToAction === appConfig.Shared.ArticleData.clickToAction.BUY_PRODUCT) {
    <product-cta-container
      [isPaidUser]="isPaidUser"
      [product]="product"
      [discount]="discount"
      [isAddRemovePending]="isAddRemovePending"
      [productInCart]="productInCart"
      [clickToAction]="clickToAction"
      [innerHTML]="innerHTML"
      [appConfig]="appConfig"
      (addToCart)="addProductToCart()"
      (removeFromCart)="removeProductFromCart()"
      (handleBuyNow)="handleBuyNow()">
    </product-cta-container>
  }
</div>
